import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TMatchForm } from "@/features/match/types/matchForm";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid } from "@mui/material";
import { Textarea } from "@/components/elements/Textarea";
import { FormField } from "@/components/elements/FormField";

type TMatchOtherInfoFormProp = {};
export const MatchOtherInfoForm: FC<TMatchOtherInfoFormProp> = () => {
  const methods = useFormContext<TMatchForm>();
  const { control } = methods;

  return (
    <InnerBox title="その他（顧客未開示の情報）">
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={6}>
          <FormField control={control} name="description">
            <Textarea clearWhiteSpace />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="note">
            <Textarea clearWhiteSpace />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
